import React from 'react';

import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';
import AnalyticsListener from '@atlaskit/analytics-next/AnalyticsListener';

export const AddAttributesWrapper = ({
	eventUpdater,
	channel,
	children,
}: {
	eventUpdater: (payload: AnalyticsEventPayload) => AnalyticsEventPayload;
	channel?: string;
	children: React.ReactNode;
}): React.JSX.Element => {
	const onEvent = (event: UIAnalyticsEvent) => {
		event.update(eventUpdater);
	};

	return (
		<AnalyticsListener onEvent={onEvent} channel={channel}>
			{children}
		</AnalyticsListener>
	);
};
